import { SupportedLanguages } from "gql/graphql";

export const SupportedLanguagesToLocale: Record<
  SupportedLanguages,
  Lowercase<SupportedLanguages>
> = {
  [SupportedLanguages.En]: "en",
  [SupportedLanguages.Kz]: "kz",
  [SupportedLanguages.Ru]: "ru",
  [SupportedLanguages.Uz]: "uz",
};
